import React from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { useSelector } from 'react-redux'
import classnames from 'classnames'
import { Scoreboard } from '@almamedia/consumer-sport-scoreboard/dist/consumer-sport-scoreboard.js'
import '@almamedia/consumer-sport-scoreboard/dist/styles.css'
import { MobileLeaderboardAd } from '../../ad/Ad'
import SidebarMenu from '../../components/layout/SidebarMenu'
import MainContent from '../../components/wrappers/MainContent'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router'
import ListTitle from '../../components/lists/ListTitle'
import GeneralSidebar from '../../components/layout/GeneralSidebar'
import './iltalehtiScoreboardView.pcss'
import { selectIsNightModeEnabled, selectUserPrimaryTheme } from '../../selectors/userSelector'
import Loading from '../../components/util/Loading'

/**
 * Meta description is a legacy of the old service.
 * @todo check to match the current situation!
 */

const scoreboardComponents = {
  Brand: () => null,
  Loading: () => <Loading loading={ false } />,
  LinkToScoreboard: ({ children }) => (
    <Link
      to='/urheilu/tulospalvelu'
      mainCategory='urheilu'
      category='tulospalvelu'
    >
      { children }
    </Link>
  ),
}

scoreboardComponents.LinkToScoreboard.propTypes = exact({
  children: PropTypes.node,
})

const IltalehtiScoreboardView = ({ path }) => {
  const nightMode = useSelector(selectIsNightModeEnabled)
  const userDarkMode = useSelector(selectUserPrimaryTheme)

  const isDarkMode = nightMode ||
    userDarkMode.includes('matrix') ||
    userDarkMode.includes('night')

  return (
    <div className='il-sports container' id='sticky-ad-bottom-boundary'>
      <div className='main-container'>
        <SidebarMenu />
        <MainContent>
          <Helmet
            title='Tulospalvelu'
            meta={ [
              {name: 'description', content: 'Ampparit.com kokoaa yhteen päivän urheilut. Mukana mm. Liiga, NHL, Veikkausliiga, Mestarien liiga sekä NBA.'},
              {property: 'og:title', content: 'Tulospalvelun päivän pelit \u2013 Ampparit.com'},
              {property: 'og:description', content: 'Ampparit.com kokoaa yhteen eri lajien tulosten liveseurannan. Mukana mm. Liiga, NHL, Veikkausliiga, Mestarien liiga, sekä NBA.'},
            ] }
          />
          <MobileLeaderboardAd path={ path } />
          <div className='il-sports__header'>
            <ListTitle heading='Tulospalvelu' />
          </div>

          <div className={ classnames('il-sports__content', { 'dark': isDarkMode }) }>
            <div className='il-scoreboard'>
              <Scoreboard components={ scoreboardComponents } />
            </div>
          </div>
        </MainContent>
        <div className='sidebar-container'>
          <GeneralSidebar />
        </div>
      </div>
    </div>
  )
}

// eslint-disable-next-line react/prefer-exact-props
IltalehtiScoreboardView.propTypes = {
  path: PropTypes.string.isRequired,
}

export default IltalehtiScoreboardView
